import {
  Box,
  Flex,
  HStack,
  IconButton,
  Image,
  Text,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  useDisclosure,
} from "@chakra-ui/react";
import smrImage6 from "@/assets/images/smr_img6.png";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { RiEqualizer2Line } from "@remixicon/react";
import SmrModelModal from "./smrmodelmodal";
import { selectMode, updateDesign } from "@/reducer/modeslice";
import { Style } from "@/types/design";
import { refreshGenCoin } from "@/store/actions";
import { useEffect } from "react";


const SmroomModel = () => {
  const dispatch = useAppDispatch();
  const modelControl = useDisclosure();

  const { design } = useAppSelector(selectMode);
  

  const handleChangeModelStrength = (value: number) => {
    const style = {...design.style, weight:value/100}
    const newdesign = { ...design, style: style };
    dispatch(updateDesign(newdesign));
  };

  const changeSmrMode = (mode: Style) => {
    const newdesign = { ...design, style: mode };
    dispatch(updateDesign(newdesign));
  };

  const handleOpenModelModal= () => {
    modelControl.onOpen();
  }

  useEffect(()=>{
    dispatch(refreshGenCoin())
  },[dispatch,design.style])

  useEffect(()=>{
    if(!design.style){
      const newdesign = { ...design, style: { name: '通用', category: '室内设计', src: 'style_generic.jpg' } };
    dispatch(updateDesign(newdesign));
    }
    
  },[design])

 

  return (
    <Box
      background="linear-gradient(40.59deg, #496AE1 72.71%, #172147 86.65%)"
      borderRadius="10px"
      p="1px"
      mt="20px"
    >
      <Box
        p="20px"
        borderRadius="10px"
        background="linear-gradient(237.85deg, #172248 9.18%, #161922 67.26%)"
      >
        <HStack>
          <Image src={smrImage6} />
          <Text fontSize={"16px"} color="#FFFFFF">
            模型（lora）
          </Text>
        </HStack>
        <Box mt="15px" bg="#0C0B10" borderRadius={"10px"} p="12px">
          <Flex alignItems={"center"} gap="20px">
            <Box flex={1}>
              {design.style?.src && (
                <Flex alignItems={"center"}>
                  <Image
                    boxSize={"80px"}
                    mr="20px"
                    objectFit={"cover"}
                    src={require(`/src/assets/design/contentstyles/${design.style.src}`)}
                    borderRadius="10px"
                  />
                  <Box flex={1}>
                    <Text mb="12px" fontSize={"16px"} color="#FFFFFF">
                      {design.style.name}
                    </Text>
                    <Flex alignItems={"center"} gap="12px">
                      <Text fontSize={"14px"} color="#6C7596">
                        模型强度
                      </Text>
                      <Slider
                        flex={1}
                        value={design.style.weight? Math.floor(design.style.weight*100) : 0}
                        step={1}
                        min={1}
                        max={100}
                        onChange={handleChangeModelStrength}
                      >
                        <SliderTrack bg="#6C7596" h="8px" borderRadius={"8px"}>
                          <SliderFilledTrack bg="linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)" />
                        </SliderTrack>
                        <SliderThumb bg="#FFFFFF" boxSize={"18px"} />
                      </Slider>
                      <Text fontSize={"14px"} color="#FFFFFF">
                        {design.style.weight? Math.floor(design.style.weight*100) : 0}%
                      </Text>
                    </Flex>
                  </Box>
                </Flex>
              )}
            </Box>
            <IconButton
              variant="unstyled"
              aria-label="picturecontrol"
              fontSize="16px"
              w="24px"
              minW={"24px"}
              h="24px"
              color="#6C7596"
              _hover={{
                color: "#ffffff",
              }}
              icon={<RiEqualizer2Line size={"24px"} />}
              onClick={handleOpenModelModal}
            />
          </Flex>
        </Box>
      </Box>
      <SmrModelModal
        isOpen={modelControl.isOpen}
        onClose={modelControl.onClose}
        changeMode={changeSmrMode}
      />
    </Box>
  );
};

export default SmroomModel;
